<template>
  <ElDialog name="update-password-modal"
    :visible="showModal"
    @open="modalOpened"
    v-on="$listeners"
    v-loading="loading"
    :title="$t('myProfile.updateYourPassword')"
    append-to-body
  >
    <div>
        <VForm :onSubmit="validateForm" data-vv-scope="password-update" ref="form">
          <div slot="row">
            <p>{{ $t('myProfile.makeSureUpdatePassword') }}</p>
            <p>{{ $t('myProfile.passwordFormatInfo') }}</p>
          </div>
          <div slot="row">
            <b>{{ $t('myProfile.newPassword') }}</b>
            <VInput
              type="password"
              key="password-update.password"
              v-model="newPassword"
              :placeholder="$t('myProfile.password')"
              :class="{ 'a-input--error': errors.has('password-update.password') }"
              v-validate="validation.password"
              data-vv-name="password"
              name="password"
              data-vv-as="password"
              ref="password"
              data-vv-scope="password-update"
              data-test="profile-password"
              data-ec="my_profile_update_password_modal"
              data-et="password_input"
              data-hj-suppress>
            </VInput>
            <VMessage
              type="error"
              subtype="basic"
              v-show="errors.has('password-update.password')"
              data-test="profile-password-error">
              <template v-slot:icon>
                <XMarkIcon />
              </template>
              <template v-slot:text>
                {{ errors.first('password-update.password') }}
              </template>
            </VMessage>
          </div>
          <div slot="row">
            <b>{{ $t('myProfile.repeatNewPassword') }}</b>
            <VInput
              type="password"
              key="password-update.password-again"
              v-model="newPasswordRepeat"
              :placeholder="$t('myProfile.confirmPassword')"
              :class="{ 'a-input--error': errors.has('password-update.password-again') }"
              v-validate="'required|confirmed:password'"
              data-vv-name="password-again"
              name="password-again"
              data-vv-as="password"
              data-vv-delay="1000"
              data-vv-scope="password-update"
              data-test="profile-password-confirm"
              data-ec="my_profile_update_password_modal"
              data-et="password_repeat_input"
              data-hj-suppress
            />
            <VMessage
              type="error"
              subtype="basic"
              data-test="profile-password-confirm-error"
              v-show="errors.has('password-update.password-again')">
              <template v-slot:icon>
                <XMarkIcon />
              </template>
              <template v-slot:text>
                {{ errors.first('password-update.password-again') }}
              </template>
            </VMessage>
          </div>
          <div slot="formButtons">
            <VButton
                :disabled="hasErrors"
                class="float-right"
                type="cta-1"
                subtype="submit"
                data-ec="my_profile_update_password_modal"
                data-et="update_button">
              {{ $t('functional.update') }}
            </VButton>
          </div>
        </VForm>
      </div>
  </ElDialog>
</template>

<script>
import VButton from '@/components/deprecated/atoms/Button.vue';
import VMessage from '@/components/deprecated/atoms/Message.vue';
import VInput from '@/components/deprecated/atoms/Input.vue';
import VForm from '@/components/deprecated/organisms/Form.vue';
import i18n from '@/locales';
import validation from '@/utils/validation';
import { XMarkIcon } from '@/components/icons/fontIcons';

export default {
  props: {
    show: Boolean,
    contact: Object,
    user: Object,
  },
  inject: {
    $validator: '$validator',
  },
  data() {
    return {
      loading: false,
      newPassword: undefined,
      newPasswordRepeat: undefined,
      password: '',
      validation,
    };
  },
  components: {
    VButton,
    VForm,
    VMessage,
    VInput,
    XMarkIcon,
  },
  computed: {
    hasErrors() {
      return !!(this.errors.items.length);
    },
    showModal() {
      return !!(this.show);
    },
  },
  methods: {
    validateForm() {
      this.$validator.validate().then((validated) => {
        if (validated) {
          this.loading = true;
          if (this.newPassword === this.newPasswordRepeat) {
            const updatedUser = {
              password: this.newPassword,
            };
            this.$store.dispatch('user/UPDATE', updatedUser).then(() => {
              this.$bus.$emit('renderGlobalMessage', ({ message: i18n.t('myProfile.messageProfileUpdated'), icon: 'check', type: 'success' }));
            }).finally(() => {
              this.loading = false;
              this.$emit('close');
            });
          }
        }
      });
    },
    modalOpened() {
      this.$validator.reset();
      this.newPassword = undefined;
      this.newPasswordRepeat = undefined;
    },
  },
};
</script>
